import { AxiosService } from './axios.service'
const baseURL = 'banner'

/**
 * Defines the API methods for banner images
 */
export default class BannerService {
	/**
	 * Get the banner images
	 * @return {Promise<number>} Banner images
	 */
	static getBannerImages() {
		return AxiosService.get(`${baseURL}/buscar-imagens`).then(
			({ data }) => data
		)
	}
}
